import React from 'react';
import { ProjectsList } from '../projects-list';
import { ProjectsContent } from '../projects-content';
import { ProjectsProvider } from '../provider';
import ProjectsSidebar from '../ProjectsSidebar';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { Menu } from '@/components/custom/menu';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';
import { ProjectWorkspace } from '@/components/custom/project';

export default function ProjectsViewDefault(props) {
  const { projectId } = props;
  const authorityLevel = useAuthorityLevel();
  const isStudent = authorityLevel === 'student';

  const Content = isStudent ? React.Fragment : DashboardContent;

  return (
    <Dashboard>
      {!isStudent && <ProjectsSidebar projectId={projectId} />}
      {isStudent && <Menu />}

      <Content
        {...(!isStudent && {
          viewMode: 'create',
          padding: 'none'
        })}
      >
        <ProjectWorkspace isStudent={isStudent}>
          <ProjectsProvider>
            <ProjectsList projectId={projectId} />
            <ProjectsContent projectId={projectId} />
          </ProjectsProvider>
        </ProjectWorkspace>
      </Content>
    </Dashboard>
  );
}
